module.exports = __webpack_public_path__ + "static/media/intervencion2.f0182df6.jpg";